import React from 'react';
import PropTypes from 'prop-types';

function MaestroCardIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke="#E1E1E1" rx="3" />
        <path fill="#0099DF" d="M27 12a6 6 0 11-12 0 6 6 0 0112 0" />
        <path fill="#EB001B" d="M13 18a6 6 0 110-12 6 6 0 010 12z" />
        <path
          fill="#6C6BBD"
          d="M19 12a6 6 0 01-2 4.5 6 6 0 01-2-4.5 6 6 0 012-4.5 6 6 0 012 4.5z"
        />
      </g>
    </svg>
  );
}

MaestroCardIcon.propTypes = {
  className: PropTypes.string,
};

export default MaestroCardIcon;
